// ======================================================================
// File: src/modules/ipe/services/ipeCostingService.js
// Purpose:
//   IPE Engineering Costing API client
//   (Aligned with backend /api/ipe/costing routes)
// ======================================================================

import axiosClient from "../../../api/axiosClient";


/**
 * ----------------------------------------------------------------------
 * COST DASHBOARD
 * ----------------------------------------------------------------------
 * Returns full costing structure:
 * summary
 * items
 * materials
 * operations
 */

async function getCostDashboard(enquiryId) {

  const res = await axiosClient.get(
    `/api/ipe/costing/dashboard/${enquiryId}`
  );

  return res.data?.data;

}


/**
 * ----------------------------------------------------------------------
 * GENERATE COST
 * ----------------------------------------------------------------------
 */

async function generateCost(enquiryId) {

  const res = await axiosClient.post(
    `/api/ipe/costing/generate/${enquiryId}`
  );

  return res.data;

}


/**
 * ----------------------------------------------------------------------
 * REGENERATE COST
 * ----------------------------------------------------------------------
 */

async function regenerateCost(enquiryId) {

  const res = await axiosClient.post(
    `/api/ipe/costing/regenerate/${enquiryId}`
  );

  return res.data;

}


/**
 * ----------------------------------------------------------------------
 * APPLY PRICING
 * ----------------------------------------------------------------------
 */

async function applyPricing(enquiryId, payload) {

  const res = await axiosClient.post(
    `/api/ipe/costing/apply-pricing/${enquiryId}`,
    payload
  );

  return res.data.data;

}

async function submitCost(enquiryId) {

  const res = await axiosClient.post(
     `/api/ipe/costing/submit/${enquiryId}`
  );

  return res.data.data;
}

async function approveCost(enquiryId) {

  const res = await axiosClient.post(
     `/api/ipe/costing/approve/${enquiryId}`
  );

  return res.data.data;
}

async function rejectCost(enquiryId) {

  const res = await axiosClient.post(
    `/api/ipe/costing/reject/${enquiryId}`
  );

  return res.data.data;
}

/**
 * ----------------------------------------------------------------------
 * COST VERSION HISTORY
 * ----------------------------------------------------------------------
 */

async function getCostVersions(enquiryId) {

  const res = await axiosClient.get(
    `/api/ipe/costing/versions/${enquiryId}`
  );

  return res.data?.data;

}
/**
 * ----------------------------------------------------------------------
 * EXPORT
 * ----------------------------------------------------------------------
 */

const ipeCostingService = {

  getCostDashboard,
  generateCost,
  regenerateCost,
  applyPricing,
   submitCost,
  approveCost,
  rejectCost,
  getCostVersions

};

export default ipeCostingService;